(() => {
  if (customElements.get('dysono-installments')) return;
  const money = cents => new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'}).format(cents / 100);
  function split(total, count) {
    return `${count}x de ${money(Math.ceil(total / count))}`;
  }
  class Installments extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const dialog = this.querySelector('dialog'), open = this.querySelector('.dysono-installments__link');
      const rows = this.querySelector('[data-installments-rows]'), total = Number(this.dataset.total);
      if (!dialog || !open || !rows || !Number.isSafeInteger(total) || total <= 0 || typeof dialog.showModal !== 'function') return;
      this.ready = true;
      for (let n=2;n<=10;n++) {
        const row=document.createElement('tr'), count=document.createElement('th'), value=document.createElement('td');
        count.scope='row'; count.textContent=`${n}x`; value.textContent=split(total,n);
        row.append(count,value); rows.append(row);
      }
      open.hidden=false;
      open.addEventListener('click',()=>{if(!dialog.open)dialog.showModal();});
      dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{
        if(e.target!==dialog)return;
        const r=dialog.getBoundingClientRect();
        if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();
      });
      dialog.addEventListener('close',()=>{if(open.isConnected)open.focus({preventScroll:true});});
    }
    disconnectedCallback() { const d=this.querySelector('dialog'); if(d?.open)d.close(); }
  }
  customElements.define('dysono-installments',Installments);
})();
